import { render, staticRenderFns } from "./workordertype-multiselect.vue?vue&type=template&id=55a316e5&"
import script from "./workordertype-multiselect.vue?vue&type=script&lang=js&"
export * from "./workordertype-multiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports